import type { ReactNode } from 'react'

import { EmptyState, Panel } from '../../ui/primitives'

/**
 * Личная переписка. Ветка сделки открывается отсюда же.
 *
 * Экран-заготовка: разметка и место под данные есть, загрузка из API
 * появится вместе с наполнением каталога.
 */
export function MessagesScreen(): ReactNode {
  return (
    <section>
      <h1>Сообщения</h1>
      <Panel>
        <EmptyState text="Пока пусто" />
      </Panel>
    </section>
  )
}
